import React, { Component } from 'react';
import {getCouponsList, getExpiredCouponsList, removeCouponItem,gregorian_to_jalali} from '../../modules/Api';
import ReactTable from 'react-table';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import ACL from '../../components/ACL';

class ExpiredCoupons extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getExpiredCouponsList(query, (res) => {this.setState({
            items: res.data.data,
            last_page: res.data.last_page,
            count: res.data.total,
            pageSize: res.data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }

    removeCoupon(id) {
        const warningMessage = `آیا از حذف کوپن اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            removeCouponItem(id, () => {
                notification.open({
                    message: `کوپن با موفقیت حذف شد!`,
                    description: `تمامی اطلاعات کوپن با موفقیت حذف شدند.`
                })
            });
            this.fetchData();
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'mpn_id',
                filterable: true,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: true,
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit" denied={() => {return row.original.title;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.title} onClick={() => {window.open(`/coupons/edit/${row.original.mpn_id}`, "_blank");}}> {row.original.title} </span></ACL>)
            },
            {
                Header: 'لینک',
                accessor: 'unique_codes_count',
                Cell: (row) => (<ACL component="div" has_permission="coupons_management|coupons_edit" denied={() => {return row.original.href;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.href} onClick={() => {window.open(`${row.original.href}`, "_blank");}}> {row.original.title} </span></ACL>)

            },
            {
                Header: 'تاریخ انقضا',
                accessor: 'coupon.expire_date',
                sortable: false,
                Cell: (row) => (
                    row.original.expiration_date==null ? <span>بدون انقضا</span> : <span title={gregorian_to_jalali(row.original.expiration_date.split(' ')[0].split('-')[0],row.original.expiration_date.split(' ')[0].split('-')[1],row.original.expiration_date.split(' ')[0].split('-')[2])}>
                        {gregorian_to_jalali(row.original.expiration_date.split(' ')[0].split('-')[0],row.original.expiration_date.split(' ')[0].split('-')[1],row.original.expiration_date.split(' ')[0].split('-')[2])}
                          </span>
                )
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                sortable: false,
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="coupons_management|coupons_delete"><span onClick={() => {this.removeCoupon(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="coupons_management|coupons_history"><span onClick={() => history.item.push(`/history/coupon/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },

        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div className="btn-container">
                    <ACL component="div" has_permission="coupons_management|coupons_add"><Button type="primary" onClick={() => { window.open(`/coupons/add`, "_blank");}}>افزودن کوپن جدید</Button></ACL>
                    <ACL component="div" has_permission="coupons_management|coupons_history"><Button type="secondary" onClick={() => history.item.push(`/history/coupon`)}>تاریخچه تغییرات</Button></ACL>
                </div>

                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default ExpiredCoupons;



// WEBPACK FOOTER //
// ./src/containers/ExpiredCoupon/index.js